
const selecionarMenu = ({commit}, menu) => {
  commit('SET_MENU_SELECIONADO', menu)
}

export {
  selecionarMenu
}